import { useContext, useEffect } from 'react';
import Header from '../../components/Header';
import IconDashboard from '../../components/icons/IconDashboard';
import { CurrentCompanyContext } from '../../hooks/CurrentCompanyContext';

export default function Billing() {
    const company = useContext(CurrentCompanyContext);

    useEffect(() => {
        if (!company) {
            return;
        }
        if (typeof window.pricewellSnippet?.initCustomerPortal === 'function') {
            window.pricewellSnippet?.initCustomerPortal?.();
        } else {
            const script = document.createElement('script');
            script.src = `${process.env.REACT_APP_SNIPPET_SERVER_URL}/customer-portal.js`;
            document.head.appendChild(script);
        }
    }, [company]);

    return (
        <div className="w-full flex flex-col h-screen overflow-y-hidden">
            <div className="w-full overflow-x-hidden border-t flex flex-col">
                <main className="w-full flex-grow p-4">
                    <Header>
                        <IconDashboard className="inline w-6 mr-3" /> Billing
                    </Header>
                    <div
                        id="pricewell-customer-portal"
                        data-id={process.env.REACT_APP_CUSTOMER_PORTAL_ID}
                        data-stripe-id={company?.stripeCustomerId}
                    ></div>
                </main>
            </div>
        </div>
    );
}
